import {
  handleSettingsSelectAll,
  handleSettingsLocationSelect,
  handleSettingsSpecificLocationSelect,
  handleSettingsMachineSelect,
  handleSettingsAddLocations,
  handleSettingsAddSpecificLocations,
  handleSettingsAddMachines,
  handleSettingsMachineSelectAlt,
} from 'features/settings/slice/force&CommandAndAdminSelectSlice';

export const SETTINGS_ACTIONS = {
  selectAll: handleSettingsSelectAll,
  locationSelect: handleSettingsLocationSelect,
  specificLocationSelect: handleSettingsSpecificLocationSelect,
  machineSelect: handleSettingsMachineSelect,
  addLocations: handleSettingsAddLocations,
  addSpecificLocations: handleSettingsAddSpecificLocations,
  addMachines: handleSettingsAddMachines,
  machineSelectAlt: handleSettingsMachineSelectAlt,
};
